import React from 'react';
import {getViewTypeByName} from '../../../../../enums/ViewType';
import { CustomCheckbox } from '../../../../../components/CustomCheckbox';
import { CustomCardGrid } from '../../../../../components/CustomCardGrid';
import ButtonActionsCard from '../../../../../components/buttons/ButtonActionsCard';
import RowCardText from '../../../../../components/RowCardText';
import NotInformation from '../../../../../components/NotInformation';
import { ArrowRightIcon } from '../../../../../components/buttons/IconButtons';
import defaultImage from '../../../../../assets/IconsButtons/ic-ingredient-card.svg';
import {colors} from '../../../../../enums/colors';
import routes from '../../../../../Routes/routes';
import {permissionObj} from '../../../../../Helpers/permission';
import { MODEL_MEASUREMENT_UNIT } from '../Model/Models';
import DisplayView from "../../../../../components/DisplayView";
import SearchSimple from "../../../../../components/SearchSimples/SearchSimple";
import CustomButtonLink from "../../../../../components/buttons/CustomButtonLink";
import IngredientsCardsApp from "../Functionality/IngredientsCardsApp";
import {EMPTY_VALUES} from "../../../../../Apis/functions";

/**
 * @Author: Cecilia López Martínez
 * @JobTitle : Full Stack Developer - IBL
 * @Email : clopez@ibl.mx
 *
 */
const IngredientsCards = ({
    view,
    setView,
    setBodyForExport,
    modified,
    setModified,
    selectedList,
    setSelectedList,
    isAllChecked,
    setIsAllChecked,
    option
}) => {
    const {
        t,
        DEV,
        navigate,
        rowsPerPage,
        searchResults,
        setSearchResults,
        permission,
        elementRef,
        searchElement,
        setSearchElement,
        search,
        setSearch,
        setSimpleSearch,
        handleDeleteAll,
        handleCheckboxChange,
        pagination,
        deletePermission
    } = IngredientsCardsApp({
        view,
        setBodyForExport,
        modified,
        setModified,
        selectedList,
        setSelectedList,
        isAllChecked,
        setIsAllChecked,
        option
    });

    return (
        <>
            <div className='d-flex'>
                <DisplayView view={view} setView={setView}/>
                <div className='w-100 ml-4'>
                    <SearchSimple
                        id={'txt_ic_search_ingredients'}
                        setBodyForExport={setBodyForExport}
                        setSearchResults={setSearchResults}
                        searchElement={searchElement}
                        setSearchElement={setSearchElement}
                        optionTable={option}
                        rowsPerPage={rowsPerPage}
                        setSimpleSearch={setSimpleSearch}
                        viewType={getViewTypeByName(view)}
                        search={search}
                        setSearch={setSearch}
                        contractorId={null}
                        supplierId={null}
                    />
                </div>
            </div>

            {searchResults?.content?.length > 0 ? (
                <>
                    { deletePermission &&
                        <div className={''}>
                            <CustomCheckbox id={"cb_av_all_checked"}
                                            trans={'de_/_select_all'}
                                            fontSize={"10px"}
                                            name={"isAllChecked"}
                                            checked={isAllChecked}
                                            onChange={(e) => {
                                                handleDeleteAll(e);
                                            }}
                            />
                        </div>
                    }
                    <div className='panelTables' ref={elementRef}>
                        <div className='row'>
                            {searchResults?.content?.map((item, index) => (
                                <CustomCardGrid
                                    isCheckboxShow={ deletePermission}
                                    itemId={item?.id}
                                    checked={selectedList?.includes(item?.id)}
                                    onCheckboxChange={handleCheckboxChange}
                                    statusColor={colors.secondary100}
                                    fontColor={colors.secondary700}
                                    borderColor={colors.secondary150}
                                    statusName={ MODEL_MEASUREMENT_UNIT[item?.measurementUnitName?.toLowerCase()]?.trans || ''}
                                    srcImage={item?.image ? `data:image/png;base64,${item?.image}` : defaultImage}
                                    isSquareImg={true}
                                    isDefaultIcon={true}
                                    btnActions={
                                        <>
                                            { (DEV || permission?.includes(permissionObj?.WEB_INGREDIENT_UPDATE) || permission?.includes(permissionObj?.WEB_INGREDIENT_READ ) ) ?
                                                <ButtonActionsCard
                                                    id={`btn_ic_actions_card_${index + 1}`}
                                                    name={ ( DEV || permission?.includes(permissionObj?.WEB_INGREDIENT_UPDATE) ) ? 'update' : 'details'}
                                                    Icon={ArrowRightIcon}
                                                    onClick={() => {
                                                        navigate(`${routes.foodieIngredient.addEdit}${item.id}`);
                                                    }}
                                                />
                                                :
                                                <></>
                                            }
                                        </>
                                    }
                                >
                                    <RowCardText title={t('name')} value={item.name || EMPTY_VALUES.DEFAULT} />
                                    <RowCardText title={t('item_code')} value={item.code || EMPTY_VALUES.DEFAULT} />
                                </CustomCardGrid>
                            ))}
                        </div>
                    </div>
                    { pagination()}
                </>
            ) : (
                <NotInformation card={true}>
                    <>
                        <div className={"warning-text"}>
                            <p>{t("you_have_not_created_any_ingredients_yet")}</p>
                        </div>
                        { ( DEV || permission?.includes(permissionObj?.WEB_INGREDIENT_CREATE) )&&
                        <CustomButtonLink
                            splitName={false}
                            id={'btn_in_create_ingredient'}
                            card={true}
                            onClick={() => {
                                navigate(routes.foodieIngredient.addEdit, { state: { view: view } });
                            }}
                            name={'add_new_ingredient'}
                        />
                        }
                    </>
                </NotInformation>
            )}
        </>
    );
};

export default IngredientsCards;
